module.exports = __webpack_public_path__ + "img/image34.3bd2410a.png";